export default __webpack_public_path__ + "static/media/Reg-last-step.04e4a11f.jpg";